
export default (copyValue, copiedText, textElement) => ({
    copyValue: copyValue,
    copiedText: copiedText,
    textElement: null,
    defaultText: '',

    init() {
        this.textElement = this.resolveElement(textElement);
        this._onClick = e => this.handleClick(e);
        this.$el.addEventListener('click', this._onClick);
    },

    destroy() {
        this.$el.removeEventListener('click', this._onClick);
    },

    copied() {
        if (this.textElement) {
            this.defaultText = this.textElement.innerText;
            this.textElement.innerText = this.copiedText;
            setTimeout(this.reset, 2000);
        }
    },

    reset() {
        if (this.textElement) {
            this.textElement.innerText = this.defaultText;
        }
    },

    copy() {
        var copyValue = typeof this.copyValue === 'function' ? this.copyValue() : this.copyValue;
        if (navigator.clipboard) {
            try {
                navigator.clipboard
                    .writeText(copyValue)
                    .then(
                        () => {
                            // succeed
                        },
                        (ex) => {
                            console.error('Copy to clipboard failed: ', ex);
                        }
                    );
            }
            catch (ex) {
                console.error('Copy to clipboard failed: ', ex);
            }
        }
        else {
            var area = document.createElement("textarea");
            area.value = copyValue;

            // Avoid scrolling to bottom
            area.style.top = "0";
            area.style.left = "0";
            area.style.position = "fixed";

            document.body.appendChild(area);
            area.focus();
            area.select();

            try {
                var successful = document.execCommand('copy');
                if (!successful) {
                    console.error('Copy to clipboard failed without error');
                }
            }
            catch (ex) {
                console.error('Copy to clipboard failed: ', ex);
            }

            document.body.removeChild(area);
        }
    },

    handleClick() {
        this.copy();
        this.copied();
    },

    resolveElement(target) {
        if (!target) {
            return this.$el;
        }

        if (target instanceof Element) {
            return target;
        }

        if (typeof target === 'string') {
            const byId = document.getElementById(target);
            if (byId) {
                return byId;
            }
            try {
                return document.querySelector(target);
            }
            catch (e) {
                return this.$el;
            }
        }

        return this.$el;
    }
});